import React from "react";
import AdminsTable from "../../../../shared/DataTable/AdminsTable";

const AdminAccount = () => {
  return (
    <div className="p-6">
      <AdminsTable />
    </div>
  );
};

export default AdminAccount;
